import { render, staticRenderFns } from "./reportview_ikid_attendance.vue?vue&type=template&id=487f1159&"
import script from "./reportview_ikid_attendance.vue?vue&type=script&lang=js&"
export * from "./reportview_ikid_attendance.vue?vue&type=script&lang=js&"
import style0 from "./reportview_ikid_attendance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports